import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { TellentCurrentUserEffects } from './store/tellent-current-user.effects';
import {
  TellentCurrentUserConfigToken,
  TellentCurrentUserNamespace,
  TellentCurrentUserReducer,
} from './store/tellent-current-user.store';

@NgModule({
  imports: [
    StoreModule.forFeature(
      TellentCurrentUserNamespace,
      TellentCurrentUserReducer,
      TellentCurrentUserConfigToken,
    ),
    EffectsModule.forFeature([TellentCurrentUserEffects]),
  ],
})
export class TellentCurrentUserDataModule {}
